import React from 'react';

import HelpButton from '../Common/HelpButton/HelpButton.jsx';
import QuestionFavoritesButton from './QuestionFavoritesButton.jsx';
import QuestionFeedbackButtons from './QuestionFeedbackButtons.jsx';

class QuestionFeedback extends React.Component {
  render() {
    return (
      <div className="feedback row mt-5">
        <div className="col-9 mb-1">
          {this.props.clicked ? (
            <div>
              <QuestionFavoritesButton
                loadFavoriteQuestion={this.props.loadFavoriteQuestion}
                toggleFavorite={this.props.toggleFavorite}
                isFavorite={this.props.isFavorite}
              />
              <QuestionFeedbackButtons
                upVotes={this.props.upVotes}
                selectedThumb={this.props.selectedThumb}
                selectThumb={this.props.selectThumb}
                userPreviousVote={this.props.userPreviousVote}
              />
              {this.props.setFavoriteMessage && (
                <div className="mt-2 text-center">
                  {this.props.setFavoriteMessage === 'add' && (
                    <span className="message-success">
                      Save question to my favorites
                    </span>
                  )}
                  {this.props.setFavoriteMessage === 'remove' && (
                    <span className="message-remove">
                      Remove question from my favorites
                    </span>
                  )}
                  {this.props.setFavoriteMessage === 'error' && (
                    <span className="message-error">
                      Error when trying to remove or add a question as a
                      favorite. Please try again later
                    </span>
                  )}
                </div>
              )}
            </div>
          ) : null}
        </div>
        {!this.props.isLoadingQuestions &&
          !this.props.errorMessageGetQuestion && (
            <div className="col-3 mb-1">
              <HelpButton question={this.props.question} />
            </div>
          )}
      </div>
    );
  }
}

export default QuestionFeedback;
